import React from 'react';

function formatCurrency(value) {
  if (value == null) return '$0';
  return '$' + Number(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

function formatMonth(period) {
  if (!period) return '';
  const [year, month] = period.split('-');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[parseInt(month) - 1]} ${year}`;
}

const TABLE_CONFIGS = {
  sales_pipeline: {
    columns: [
      { key: 'group_label', label: 'Group' },
      { key: 'stage_name', label: 'Stage' },
      { key: 'count', label: 'Deals', align: 'right' },
      { key: 'total_amount', label: 'Amount', format: 'currency', align: 'right' },
    ],
  },
  revenue: {
    columns: [
      { key: 'period', label: 'Period', format: 'month' },
      { key: 'group_label', label: 'Group' },
      { key: 'order_count', label: 'Orders', align: 'right' },
      { key: 'revenue', label: 'Revenue', format: 'currency', align: 'right' },
    ],
  },
  forecast: {
    columns: [
      { key: 'period', label: 'Period', format: 'month' },
      { key: 'group_label', label: 'Group' },
      { key: 'count', label: 'Deals', align: 'right' },
      { key: 'total_amount', label: 'Pipeline', format: 'currency', align: 'right' },
      { key: 'weighted_amount', label: 'Weighted', format: 'currency', align: 'right' },
    ],
  },
};

export default function ReportTable({ reportType, data }) {
  if (!data || data.length === 0) return null;

  const config = TABLE_CONFIGS[reportType];
  if (!config) return null;

  return (
    <div className="report-table-wrapper">
      <table className="report-table">
        <thead>
          <tr>
            {config.columns.map(col => (
              <th key={col.key} style={{ textAlign: col.align || 'left' }}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {config.columns.map(col => {
                let value = row[col.key];
                if (col.format === 'currency') value = formatCurrency(value);
                else if (col.format === 'month') value = formatMonth(value);
                else value = value ?? '';

                return (
                  <td key={col.key} style={{ textAlign: col.align || 'left' }}>{value}</td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
